import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '../index';

export default function PageTitle({ texto, translationId, hasStickyActionsHeader }) {
  return ((translationId) ? <Text color="#444963" fontSize="24" mb={hasStickyActionsHeader ? 0 : '16'} translationId={translationId} /> : <Text fontSize="24" mb={hasStickyActionsHeader ? 0 : '16'}>{texto}</Text>);
}

PageTitle.propTypes = {
  texto: PropTypes.string,
  translationId: PropTypes.string,
  hasStickyActionsHeader: PropTypes.bool,
};

PageTitle.defaultProps = {
  texto: '',
  translationId: undefined,
  hasStickyActionsHeader: false,
};
